module.exports = __webpack_public_path__ + "static/media/icon-retiro.c8dbc321.svg";